module.exports = __webpack_public_path__ + "io-bottom.svg?df284b517fb2b1ef28922b708c3c171e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/io-bottom.svg
// module id = 86
// module chunks = 0